import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlags, FeatureFlags } from '../../contexts/FeatureFlagsContext';
import { useAuth } from '../../contexts/CustomAuthContext';

interface FeatureGatedRouteProps {
  featureKey: keyof FeatureFlags;
  children: React.ReactNode;
  /** Where to redirect when the feature is disabled for the user. Defaults to "/" */
  redirectTo?: string;
}

/**
 * Wraps a route and renders it only when the feature flag is enabled.
 * Admins always pass through regardless of the flag value.
 */
const FeatureGatedRoute: React.FC<FeatureGatedRouteProps> = ({
  featureKey,
  children,
  redirectTo = '/',
}) => {
  const { isEnabled, loading } = useFeatureFlags();
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';

  // While flags are loading, render nothing to avoid flash-of-redirect
  if (loading) return null;

  if (!isEnabled(featureKey, isAdmin)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default FeatureGatedRoute;
